// extracted by mini-css-extract-plugin
export default {"container":"Skills_container__0x8mU","wrapper":"Skills_wrapper__MNX7X","topVector":"Skills_topVector__bAMzI","bottomVector":"Skills_bottomVector__gkdub"};